import { rankWith, isControl, scopeEndsWith, and } from '@jsonforms/core';

export const datePaidSubTester = rankWith(
  3, // rank should be higher than the default renderers
  and(isControl, scopeEndsWith('paid_subscription_ends')) // replace 'yourPath' with the appropriate value
);
